(function ($) {
	var touchsupport = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)
	if (!touchsupport) {
		$('body').addClass('non-touch');
	}

	//Form
	$('.form-group input[type="text"], .form-group textarea').on('focus', function () {
		$(this).parent().addClass('focus');
	}).on('blur', function () {
		if (!$(this).val()) {
			$(this).parent().removeClass('focus');
		}
	});
		
	$('.form-group input[type="checkbox"]').on('click', function () {
		if ($(this).is(':checked')) {
			$(this).parent().addClass('focus');
		} else {
			$(this).parent().removeClass('focus');
		}
	});
	
	$('.form-group input[type="radio"]').on('click', function () {
		$(this).closest('.radio').find('.focus').removeClass('focus');
		if ($(this).is(':checked')) {
			$(this).parent().addClass('focus');
		}
	});

	var today = new Date();
	var year = today.getFullYear() + 3;
	$('.date-field input[type="text"]').datepicker({
		dateFormat: "dd/mm/yy",
		firstDay: 1,
		showButtonPanel: true,
		closeText: "Close",
		currentText: "",
		changeMonth: true,
		changeYear: true,
		yearRange: "1946:" + year
	});
	//.on('blur',function (){$(this).datepicker("hide");})

	if ($('.grid-item').length > 0) {
		$('.grid-item a.small-block-cta').featherlightGallery({
			previousIcon: '',
			nextIcon: '',
			galleryFadeIn: 100,
			galleryFadeOut: 300
		});
	}


	//Person CTA
	if (!Modernizr.objectfit) {
		$('.person-cta').each(function () {
			var $imageContainer = $(this).find('.cta-img'),
				imgUrl = $imageContainer.find('img').prop('src');
			if (imgUrl) {
				$imageContainer
					.css('backgroundImage', 'url(' + imgUrl + ')')
					.addClass('object-fit');
			}
		});
	}

	// remove default alt from any images
	$('img').each(function () {
		var $this = $(this),
			imgAlt = $this.attr('alt');
		if (imgAlt === "default-boe-image") {
			$(this).attr('alt', '');
		}
	});

})(jQuery);